export default __webpack_public_path__ + "static/media/LinkidIn.4a5cfbde.svg";